import script from "./SolutionTemplate.vue?vue&type=script&setup=true&lang=js"
export * from "./SolutionTemplate.vue?vue&type=script&setup=true&lang=js"

import "./SolutionTemplate.vue?vue&type=style&index=0&id=c35f7c48&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c35f7c48"]])

export default __exports__